import { z } from "zod";

export const genderSchema = z.enum(["MALE", "FEMALE", "OTHER", "UNSPECIFIED"]);

/**
 * docs/api-design.md §9.2 explicitly forbids updating `status`,
 * `emailVerifiedAt`, `phoneVerifiedAt`, and `roles` through this endpoint —
 * this schema simply never accepts those fields.
 */
export const updateUserProfileSchema = z.object({
  displayName: z.string().trim().min(1).max(150).optional(),
  firstName: z.string().trim().min(1).max(100).optional(),
  lastName: z.string().trim().min(1).max(100).optional(),
  phoneNumber: z
    .string()
    .trim()
    .regex(/^[0-9+\-\s]{6,30}$/, "Invalid phone number.")
    .optional(),
  gender: genderSchema.optional(),
  birthDate: z.string().date().optional(),
  profileImageUrl: z.string().trim().url().optional(),
});
export type UpdateUserProfileInput = z.infer<typeof updateUserProfileSchema>;
